import React from 'react';

// Import image
import contactSupport from "../assets/img/contact-support.png";
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import { Link } from 'react-router-dom';

const ContactPage = () => {
  return (
    <div>
        <Header/>
      {/* Header Start */}
      <div className="container-fluid bg-breadcrumb">
        <div className="container text-center py-5" style={{ maxWidth: '900px' }}>
          <h4 className="text-white display-4 mb-4 wow fadeInDown" data-wow-delay="0.1s">Contact Us</h4>
          <ol className="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown" data-wow-delay="0.3s">
            <li className="breadcrumb-item">
              <Link to={"/"}>Home</Link>
            </li>
            <li className="breadcrumb-item">
              <a href="#">Pages</a>
            </li>
            <li className="breadcrumb-item active text-primary">Contact</li>
          </ol>
        </div>
      </div>
      {/* Header End */}

      {/* Contact Start */}
      <div className="container-fluid contact bg-light py-5">
        <div className="container py-5">
          <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{ maxWidth: '800px' }}>
            <h4 className="text-primary">Contact Us</h4>
            <h1 className="display-4 mb-4">If you have any comments please Contact</h1>
          </div>
          <div className="row g-5">
            {/* Contact Image */}
            <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
              <div className="contact-img d-flex justify-content-center">
                <div className="contact-img-inner">
                  <img src={contactSupport} className="img-fluid w-100" alt="Contact Support" />
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-xl-6 wow fadeInRight" data-wow-delay="0.4s">
              <div>
                <h4 className="text-primary">Send Your Message</h4>
                <form>
                  <div className="row g-3">
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input type="text" className="form-control border-0" id="name" placeholder="Your Name" />
                        <label htmlFor="name">Your Name</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input type="email" className="form-control border-0" id="email" placeholder="Your Email" />
                        <label htmlFor="email">Your Email</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input type="phone" className="form-control border-0" id="phone" placeholder="Phone" />
                        <label htmlFor="phone">Your Phone</label>
                      </div>
                    </div>
                    <div className="col-lg-12 col-xl-6">
                      <div className="form-floating">
                        <input type="text" className="form-control border-0" id="project" placeholder="Project" />
                        <label htmlFor="project">Your Project</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <input type="text" className="form-control border-0" id="subject" placeholder="Subject" />
                        <label htmlFor="subject">Subject</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-floating">
                        <textarea className="form-control border-0" placeholder="Leave a message here" id="message" style={{ height: '120px' }}></textarea>
                        <label htmlFor="message">Message</label>
                      </div>
                    </div>
                    <div className="col-12">
                      <button className="btn btn-primary w-100 py-3">Send Message</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Contact Details */}
            <div className="col-12">
              <div>
                <div className="row g-4">
                  <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                    <div className="contact-add-item">
                      <div className="contact-icon text-primary mb-4">
                        <i className="fas fa-map-marker-alt fa-2x"></i>
                      </div>
                      <div>
                        <h4>Address</h4>
                        <p className="mb-0">No:3rd Floor, RSB Towers, Sai Baba Colony Metupalayam Rd, Near Sai Baba Temple, Coimbatore, Tamilnadu - 641043, India</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.4s">
                    <div className="contact-add-item">
                      <div className="contact-icon text-primary mb-4">
                        <i className="fas fa-envelope fa-2x"></i>
                      </div>
                      <div>
                        <h4>Mail Us</h4>
                        <p className="mb-0">techsupport@epic-x.io</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.6s">
                    <div className="contact-add-item">
                      <div className="contact-icon text-primary mb-4">
                        <i className="fa-solid fa-phone fa-2x"></i>
                      </div>
                      <div>
                        <h4>Call Us</h4>
                        <p className="mb-0">+91-8925696660</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.8s">
                    <div className="contact-add-item">
                      <div className="contact-icon text-primary mb-4">
                        <i className="fa-solid fa-clock fa-2x"></i>
                      </div>
                      <div>
                        <h4>Open Hours</h4>
                        <p className="mb-0">Monday - Friday 10:00 AM - 05:00 PM</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Google Map */}
            <div className="col-12 wow fadeInUp" data-wow-delay="0.2s">
              <div className="rounded">
                <iframe
                  className="rounded w-100"
                  width="100%"
                  height="400"
                  frameBorder="0"
                  scrolling="no"
                  marginHeight="0"
                  marginWidth="0"
                  src="https://maps.google.com/maps?width=100%25&amp;height=400&amp;hl=en&amp;q=No:3rd%20Floor,%20RSB%20Towers,%20Sai%20Baba%20Colony%20Metupalayam%20Rd,%20Near%20Sai%20Baba%20Temple,%20Coimbatore,%20Tamilnadu%20-%20641043,%20India+(https://epic-x.io/)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                >
                  <a href="https://www.gps.ie/"></a>
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Contact End */}
      <Footer/>
    </div>
  );
};

export default ContactPage;